import { useEffect, useState } from 'react'

/**
 * Replaces the nested-`setTimeout` "is the user still typing?" dance in
 * GiveawayNew and new_giveaway/game_info, which raced (25ms then 50ms) and
 * still fired a request per keystroke on a slow connection.
 */
export function useDebouncedValue<T>(value: T, delayMs = 250): T {
  const [debounced, setDebounced] = useState(value)

  useEffect(() => {
    const id = window.setTimeout(() => setDebounced(value), delayMs)
    return () => window.clearTimeout(id)
  }, [value, delayMs])

  return debounced
}
